import React from 'react'

export const UserDetail = () => {
    return <div>UserDetail</div>
}
